import { Typography as MuiTypography, TypographyProps as TypographyProps } from '@mui/material';

export const Typography: React.FC<
  TypographyProps & {
    children?: React.ReactNode;
  }
> = ({ children, ...props }) => {
  return <MuiTypography {...props}>{children}</MuiTypography>;
};
